import PropTypes from "prop-types";
import React, { forwardRef, useEffect, useRef, useState } from "react";

import styled from "styled-components/macro";

import FnrButton, { ButtonText } from "UI/FnrButton3";
import { FnrPopover } from "UI/FnrPopover2";

import { useWindowSize } from "Utilities/Hooks/useWindowSize";

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  max-height: 32px;
  margin-top: 0.4rem;

  @media (max-width: 1180px) {
    margin-bottom: 5px;
  }

  @media (max-width: 480px) {
    display: none;
  }
`;

export const MultiButtonsHolder = styled.div`
  display: flex;
  align-items: center;
`;

const PopoverIcon = styled.span`
  font-size: 21px;
  margin-right: 6px;
`;

export const ActionButton = forwardRef(
  ({ clickHandler, text, icon, color, ...rest }, ref) => {
    const windowSize = useWindowSize();

    const getButtonSize = () => {
      if (windowSize.width < 1025) return "small";
      return "medium";
    };
    return (
      <FnrButton
        color={color}
        onClick={clickHandler}
        size={getButtonSize()}
        ref={ref}
        {...rest}
      >
        {icon}
        <ButtonText>{text}</ButtonText>
      </FnrButton>
    );
  }
);

export const ActionButtonWithPopover = ({
  text,
  icon,
  color,
  renderPopoverOptions,
  closePopover,
  ...rest
}) => {
  const [showPopover, setShowPopover] = useState(false);
  const buttonRef = useRef();
  const togglePopover = () => {
    setShowPopover(!showPopover);
  };

  useEffect(() => {
    if (closePopover) {
      setShowPopover(false);
    }
  }, [closePopover]);

  return (
    <>
      <ActionButton
        clickHandler={togglePopover}
        text={text}
        ref={buttonRef}
        color={color}
        icon={icon}
        {...rest}
      />
      <FnrPopover
        // style={popoverStyle}
        show={showPopover}
        buttonRef={buttonRef}
        onShouldClose={() => setShowPopover(false)}
        style={{ minWidth: "0" }}
      >
        {renderPopoverOptions()}
      </FnrPopover>
    </>
  );
};

export const PopoverButton = ({
  clickHandler,
  text,
  icon,
  size,
  color,
  ...rest
}) => {
  return (
    <FnrButton onClick={clickHandler} size={size} color={color} {...rest}>
      <PopoverIcon className={icon} />
      {text}
    </FnrButton>
  );
};

ActionButton.propTypes = {
  clickHandler: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  icon: PropTypes.node,
  color: PropTypes.string,
};

ActionButtonWithPopover.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.node,
  color: PropTypes.string,
  renderPopoverOptions: PropTypes.func.isRequired,
  closePopover: PropTypes.bool,
};

PopoverButton.propTypes = {
  clickHandler: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  icon: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
};
